module.exports = __webpack_public_path__ + "img/MBbio.78301e3c.jpg";